// import store from '@/store'
import swal from 'sweetalert2';

export const alert = (arg) => {
  return new Promise(function(resolve, reject) {
    if((typeof arg) === 'string'){
      swal.fire(arg).then((rs) => {
        if (rs.value) {
          resolve();
        }
      });
    }
    if((typeof arg) === 'object'){
      swal.fire(arg).then((rs) => {
          if (rs.value) {
            resolve();
          }
        });
    }
  });

};

export const confirm = (content) => {
  return new Promise(function(resolve, reject) {
    swal.fire({
      text: content,
      showCancelButton: true,
    }).then((rs) => {
      if (rs.value) {
        resolve();
      }
    });
  });
};
